import type { ReactNode } from 'react'
import React from 'react'

import * as S from './PodcastsList.styled'

type PodcastsListProps = {
  children: ReactNode
}

export const PodcastsList = ({ children }: PodcastsListProps) => (
  <S.Container>{children}</S.Container>
)
